import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Layers } from '@helpers/layers';
import srOnly from '@helpers/srOnly';
import { h6 } from '@helpers/typography';
import { rgba } from 'polished';
import styled from 'styled-components';
import ButtonStyles from '../Button/Button.styles';
const Container = styled.aside `
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  background: ${brand.white};
  flex-direction: column;
  height: 100%;
  max-width: 354px;
  width: 100%;
  z-index: ${Layers.Modal};
`;
const Header = styled.header `
  padding: 24px;
`;
const Title = styled.h2 `
  ${h6}

  ${fonts.brandonGrotesque.bold}
  margin: 0;
  text-transform: uppercase;
`;
const Body = styled.div `
  overflow-y: auto;
  padding: 0 24px;
`;
const OptionList = styled.ul `
  display: flex;
  flex-direction: column;
`;
const OptionItem = styled.li `
  display: block;
`;
const OptionButton = styled.button `
  ${ButtonReset}

  display: flex;
  align-items: center;
  color: currentColor;
  ${fonts.brandonGrotesque.medium}
  font-size: 18px;
  line-height: 1em;
  padding: 16px 0;
  text-decoration: none;
  text-underline-position: under;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const OptionIcon = styled.span `
  display: block;
  height: 32px;
  margin-right: 18px;
  width: 32px;
`;
const PinboardList = styled.ul `
  display: flex;
  flex-direction: column;
`;
const PinboardListItem = styled.li `
  display: block;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;
const ActionList = styled.footer `
  display: flex;
  gap: 8px;
  margin-top: auto;
  padding: 8px;

  ${ButtonStyles.Container} {
    flex: 1 1 50%;
    justify-content: center;
  }
`;
const Form = styled.form `
  display: block;
`;
const Label = styled.label `
  ${srOnly}
`;
const Input = styled.input `
  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  border: 1px solid ${brand.greyMid};
  color: ${rgba(brand.black, 0.5)};
  ${fonts.brandonGrotesque.regular}
  font-size: 18px;
  height: 54px;
  padding: 12px 20px;
  width: 100%;
`;
const PinboardActionDrawerStyles = {
    ActionList,
    Body,
    Container,
    Form,
    Header,
    Input,
    Label,
    OptionButton,
    OptionIcon,
    OptionItem,
    OptionList,
    PinboardList,
    PinboardListItem,
    Title,
};
export default PinboardActionDrawerStyles;
